// @flow

import VehicleInfoApp from './VehicleInfoApp'
import VehiclePriceApp from './VehiclePriceApp'
import VehicleWindscreenApp from './VehicleWindscreenApp'
import CicEnableApp from './CicEnableApp'
import PhoneApp from './PhoneApp'
import BonusMalusApp from './BonusMalusApp'
import SeatsMiniApp from './SeatsMiniApp'
import PdfMiniApp from './PdfMiniApp'
import DiscountsMiniApp from './DiscountsMiniApp'
import CheckboxEnableApp from './CheckboxEnableApp'
import EquipmentMiniApp from './EquipmentMiniApp'
import OwnerRadioApp from './OwnerRadioApp'
import ChildrenMiniApp from './ChildrenMiniApp'
import CheckboxMiniApp from './CheckboxMiniApp'
import AcquisitionCppMiniApp from './AcquisitionCppMiniApp'
import PillowGaragedMiniApp from './PillowGaragedMiniApp'
import EquipmentPillowMiniApp from './EquipmentPillowMiniApp'

// types
import type { ProductContent } from '../../Core/Types/ProductContent'
import type { ImmutableType } from '../../Core/Types/ImmutableTypes'
import type { InputHelpType } from '../../Core/Types/InputHelpType'
import type { ExpandedSpecificationDTO } from '../../Core/Types/Field'
import type { ActiveSettingsType } from '../../Core/Types/SettingsTypes'
import type { FormValueType } from '../../Core/Types/Values'
import type { ArrayFieldFormTypes } from '../../Core/Types/ArrayFieldFormType'

export type DefaultMiniAppProps = {
  arrayTypes: ArrayFieldFormTypes,
  activeSettings: ActiveSettingsType,
  content: ProductContent,
  data: Object & ImmutableType, // relative data
  formData: Object & ImmutableType,
  fullContent: ProductContent,
  fullSpecification?: ExpandedSpecificationDTO,
  inputHelps: InputHelpType,
  isBackOffice: boolean,
  miniAppData: Object,
  onChangeFieldVisibility: (fieldPath: string, hidden: boolean) => void,
  onChangeFormData: (formData: Object & ImmutableType, keys: Array<string>) => void,
  onChangeValue: (key: string, value: FormValueType, pathArray?: Array<string | number>) => void,
  prefix: string,
  pushIsPristine: boolean,
  resources: Object,
  specification?: ExpandedSpecificationDTO,
  token: string,
  validationErrors: { [key: string]: { [key: string]: string } },
}

export default {
  bonusMalusApp: BonusMalusApp,
  checkboxEnableApp: CheckboxEnableApp,
  checkboxMiniApp: CheckboxMiniApp,
  childrenMiniApp: ChildrenMiniApp,
  cicEnableApp: CicEnableApp,
  discountsMiniApp: DiscountsMiniApp,
  equipmentMiniApp: EquipmentMiniApp,
  ownerRadioApp: OwnerRadioApp,
  pdfMiniApp: PdfMiniApp,
  phoneApp: PhoneApp,
  seatsMiniApp: SeatsMiniApp,
  vehicleInfoApp: VehicleInfoApp,
  vehiclePriceApp: VehiclePriceApp,
  vehicleWindscreenApp: VehicleWindscreenApp,
  acquisitionCppMiniApp: AcquisitionCppMiniApp,
  pillowGaragedMiniApp: PillowGaragedMiniApp,
  equipmentPillowMiniApp: EquipmentPillowMiniApp,
}
